import styled, { css } from 'styled-components';
import { fromMd } from '../../../../constants/breakpoints';
import { backgroundImageToScreenRatioAtDesktopBreakpoint, spacingBetweenIconAndInitialsViewWidthUnits, } from '../dimensions';
export const Body = styled.div `
  display: flex;
  align-items: center;
  position: absolute;
  z-index: ${o => o.theme.zIndex.foregroundContent};
`;
export const Image = styled.img(o => css `
    height: calc(clamp(8px, 4.5vw, 48px) * ${o.scale});
    width: calc(clamp(8px, 4.5vw, 48px) * ${o.scale});
    ${fromMd} {
      height: calc(clamp(12px, 2vw, 48px) * ${o.scale});
      width: calc(clamp(12px, 2vw, 48px) * ${o.scale});
    }
  `);
export const Initials = styled.span `
  color: ${props => props.color};
  font-family: Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: clamp(8px, 2vw, 32px);
  letter-spacing: 0.69px;
  margin-left: ${spacingBetweenIconAndInitialsViewWidthUnits}vw;

  ${fromMd} {
    font-size: clamp(8px, 1vw, 32px);
    margin-left: ${spacingBetweenIconAndInitialsViewWidthUnits *
    backgroundImageToScreenRatioAtDesktopBreakpoint}vw;
  }
`;
//# sourceMappingURL=styles.js.map